import { text } from '@/constants/Styles';
import Card from '@/components/Card';
import { ThemeText } from "@/components/Theme";
import { StyleSheet } from "react-native";
import { useWindowStore } from '@/stores/useWindowStore';

export const ShowMoreButton = (props) => {

    const {
        light = 'white',
        dark = 'muted.800',
        style = {},
        onPress = null,
        width = null,
        height = 60,
        ...rest
    } = props;

    const isNative = useWindowStore((s) => s.isNative);
    const responsiveStyle = isNative ? {width: width, aspectRatio: 3/4} : {flex: 1};

    return (
        <Card 
            onPress={onPress}
            light={light} 
            dark={dark}
            style={[styles.button, style, responsiveStyle]} 
            {...rest}  
        >
            <ThemeText 
                light={dark} 
                dark={light}
                style={[text.h1, text.uc]}
                id={'more'}
            />
        </Card>
    )
};

const styles = StyleSheet.create({
    button: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    }
});